(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'VaxReservationPricing',
	};

	var _airChange,
	    _customParseFloat,
	    _firstGuestPrice,
	    _getAirCommissionAmt,
	    _perGuestPricing,
	    _priceChange,
	    _round,
	    _toggleAirChargeTotal,
	    _toggleAirCommissionTotal,
	    _updateChargeTotals,
	    _updateCommissionColumns,
	    _updateCommissionTotals,
	    _updateGrandTotals,
	    _updatePackageChargeTotal,
	    _updateRowPricing,
	    guest_count;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		guest_count = parseInt($('form[name="' + form.name + '"]').data('guest-ct'));

		// toggling between "includes Air"
		$('.tp-sp-includes-air-button').on('change', function change (e) {
			var $radio = $(this);

			if ($radio.val() === '1') {
				$('.tp-sp-total-air-price').removeClass('hidden');
				$('.tp-sp-air-commission-rate').removeClass('hidden');
			} else {
				$('#estimated-air-price').val('0.00');
				_airChange();
				_priceChange();

				$('.tp-sp-total-air-price').addClass('hidden');
				$('.tp-sp-air-commission-rate').addClass('hidden');
			}
		});

		$('.tp-sp-field').on('keyup', function change (e) {
			var $self         = $(this),
			    price_row     = $self.data('price-row');

			if ( (price_row === 'total_air_price') || (price_row === 'air_commission_rate') ) {
				_airChange();
			}

			_priceChange();
		});

		$('#acknowledgement').on('click', function click (e) {
			var checked = $(this).is(":checked");

			$('#save_button').prop('disabled', !checked);
		});
	};

	// form.success = function success(response)
	// {
	// };

	_airChange = function _airChange()
	{
		_toggleAirChargeTotal();
		_toggleAirCommissionTotal();
	};

	_customParseFloat = function _customParseFloat(val)
	{
		return ((val.length) ? parseFloat(val) : 0.00);
	};

	// price for 1st guest may vary due to rounding and dividing odd numbers
	_firstGuestPrice = function _firstGuestPrice(total, pp_price)
	{
		var diff = _round(total - (pp_price * guest_count));

		if (diff !== 0) {
			return (pp_price + diff);
		}
		return pp_price;
	};

	_getAirCommissionAmt = function _getAirCommissionAmt()
	{
		var air_price     = _customParseFloat($('#estimated-air-price').val()),
		    air_comm_rate = _customParseFloat($('#air_commission_rate').val()),
		    air_comm      = 0.00;

		if ((air_price <= 0) || (air_comm_rate <= 0)) {
			return air_comm;
		}

		return (air_price * (air_comm_rate / 100));
	};

	_perGuestPricing = function _perGuestPricing(price)
	{
		return _round(price / guest_count);
	};

	_priceChange = function _priceChange()
	{
		_updatePackageChargeTotal();
		_updateGrandTotals();
		_updateCommissionTotals();
	};

	_round = function _round(num)
	{
		return parseFloat(num.toFixed(2));
	};

	_toggleAirChargeTotal = function _toggleAirChargeTotal()
	{
		var air_pp_price = _updateRowPricing($('#estimated-air-price').val(), 'tp-cht-air', 'hidden-air-charge');
		_updateChargeTotals();

		// show "air charge total" row
		if (air_pp_price > 0) {
			$('.tp-cht-row-air').removeClass('hidden');

		// hide "air charge total" row
		} else {
			$('.tp-cht-row-air').addClass('hidden');
		}
	};

	_toggleAirCommissionTotal = function _toggleAirCommissionTotal()
	{
		var air_comm = _getAirCommissionAmt();

		_updateRowPricing(air_comm, 'tp-cot-air', 'hidden-air-comm');

		if (air_comm > 0) {
			$('.tp-cot-row-air').removeClass('hidden');
		} else {
			$('.tp-cot-row-air').addClass('hidden');
		}
	};

	_updateCommissionColumns = function _updateCommissionColumns()
	{
		$('.hidden-package-comm').each(function loop(index, el) {
			var val     = parseFloat($(el).html()),
			    air_val = parseFloat($('.hidden-air-comm').eq(index).html()),
			    total   = (val + air_val);

			$('.tp-cot-total').eq(index).html(accounting.formatMoney(total));
		});
	};

	_updateCommissionTotals = function _updateCommissionTotals()
	{
		var pkg_comm = _customParseFloat($('#total-commission').val()),
		    air_comm = _getAirCommissionAmt(),
		    grand    = _customParseFloat($('#total-commission').val());

		if (air_comm >= pkg_comm) {
			pkg_comm = 0.00;
		} else {
			pkg_comm = (pkg_comm - air_comm);
		}

		_updateRowPricing(pkg_comm, 'tp-cot-package', 'hidden-package-comm');
		_updateCommissionColumns();

		if (air_comm >= grand) {
			grand = air_comm;
		}

		// updates Commission Grand Total
		$('.tp-cot-grand-total').html(accounting.formatMoney(grand));
	};

	_updateGrandTotals = function _updateGrandTotals()
	{
		var pkg_price     = _customParseFloat($('#total-package-price').val()),
		    air_price     = _customParseFloat($('#estimated-air-price').val()),
		    pkg_price_fmt;

		if (air_price >= pkg_price) {
			pkg_price = air_price;
		}

		pkg_price_fmt = accounting.formatMoney(pkg_price);

		$('.tp-cgt-total').html(pkg_price_fmt);
	};

	_updatePackageChargeTotal = function _updatePackageChargeTotal()
	{
		var pkg_price = _customParseFloat($('#total-package-price').val()),
		    air_price = _customParseFloat($('#estimated-air-price').val()),
		    diff      = (pkg_price - air_price);

		if (diff < 0) {
			diff = 0;
			$('.tp-cht-package').html(accounting.formatMoney(diff));
		}

		_updateRowPricing(diff, 'tp-cht-package', 'hidden-package-charge');    // Package Charge Total row
		_updateChargeTotals();
	};

	// update the Charge Totals row by adding package charge with air charge
	_updateChargeTotals = function _updateChargeTotals()
	{
		$('.hidden-package-charge').each(function loop(index, el) {
			var val     = parseFloat($(el).html()),
			    air_val = parseFloat($('.hidden-air-charge').eq(index).html()),
			    total   = (val + air_val);

			$('.tp-cht-total').eq(index).html(accounting.formatMoney(total));
		});
	};

	// sets the prices for a row of guests
	_updateRowPricing = function _updateRowPricing(val, css_class, hidden_css)
	{
		var price             = parseFloat(val),
		    pp_price          = _perGuestPricing(price),
		    first_guest_price = _firstGuestPrice(price, pp_price);

		$('.' + hidden_css).html(accounting.toFixed(pp_price, 2));

		$('.' + css_class).html(accounting.formatMoney(pp_price));

		// set first guest price
		$('.' + hidden_css + ':first').html(accounting.toFixed(first_guest_price, 2));
		$('.' + css_class + ':first').html(accounting.formatMoney(first_guest_price));

		return pp_price;
	};

}(jQuery, window.Adzuki || {}));
